import {
  Box,
  Container,
  Grid,
  Link,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import {
  Facebook,
  LinkedIn,
  Instagram,
  YouTube,
  LocationOn,
  Phone,
  Email,
} from "@mui/icons-material";
import logo from "../assets/BurjLogo.jpg";
import { Link as RouterLink } from "react-router-dom";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

const footerLinks = [
  { label: "About Us", url: "/about-us" },
  // { label: "Our Projects", url: "/projects" },
  // { label: "Certifications", url: "/certifications" },
  // { label: "Careers", url: "/careers" },
  { label: "Contact Us", url: "/contact-us" },
  { label: "Privacy Policy", url: "/privacy-policy" },
  { label: "Terms & Conditions", url: "/terms-and-conditions" },
  { label: "FAQs", url: "/faqs" },
];

const productCategories = [
  "Acoustic Enclosures",
  "Drop-Over Enclosures",
  "Fuel Tanks",
  "Skid Frames",
  "Pressure Vessels",
  "Containerized Modules",
];

const serviceCategories = [
  "Fabrication & Engineering",
  "Acoustic Solutions",
  "Oil & Gas Skid Solutions",
  "Metal Structures",
  "Custom Projects",
];

export default function Footer() {
  const year = new Date().getFullYear();

  const slugify = (text) =>
    text
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");

  return (
    <Box
      sx={{
        // bgcolor: brandBlue,
        background: "linear-gradient(135deg, #0d0f19, #111627, #0b0e18)",
        // bgcolor: "#0d0d0d",
        color: "#dddddd",
        pt: 8,
        pb: 4,
        // mt: 1,
        borderTop: `6px solid ${brandRed}`,
        // mt: 10,
      }}
    >
      <Container maxWidth="lg">
        {/* ROW 1 — Company + Contact (FLEXBOX) */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: 4,
            mb: 4,
          }}
        >
          {/* Company Info */}
          <Box sx={{ flex: "1 1 300px", minWidth: "300px" }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <Box
                component="img"
                src={logo}
                alt="Burj Logo"
                sx={{ height: 55, mr: 1.5, borderRadius: "50%" }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  lineHeight: 1.2,
                  color: "#fff",
                }}
              >
                Burj Al Yarmouk Industries LLC
              </Typography>
            </Box>

            <Typography
              variant="body2"
              sx={{ color: "#aaa", mb: 2, width: "80%" }}
            >
              Trusted provider of acoustic enclosures, metal fabrication
              solutions, industrial fuel tanks, modular structures, and
              engineered metal products.
            </Typography>

            <Box sx={{ mt: 2 }}>
              <IconButton
                component={RouterLink}
                to="https://www.linkedin.com/in/burj-al-yarmouk-industries-llc-417570347"
                target="_blank"
                sx={{ color: "#fff", "&:hover": { color: brandRed } }}
              >
                <LinkedIn />
              </IconButton>
              {/* <IconButton
                sx={{ color: "#fff", "&:hover": { color: brandRed } }}
              >
                <Facebook />
              </IconButton>
               */}
              <IconButton
                component={RouterLink}
                to="https://www.instagram.com/burjalyarmouk"
                target="_blank"
                sx={{ color: "#fff", "&:hover": { color: brandRed } }}
              >
                <Instagram />
              </IconButton>
              {/* <IconButton
                sx={{ color: "#fff", "&:hover": { color: brandRed } }}
              >
                <YouTube />
              </IconButton> */}
            </Box>
          </Box>

          {/* Contact Info */}
          <Box sx={{ flex: "1 1 300px", minWidth: "300px" }}>
            <Typography
              variant="subtitle1"
              sx={{
                color: "#fff",
                fontWeight: "bold",
                mb: 2,
                textTransform: "uppercase",
              }}
            >
              Contact
            </Typography>

            <Box sx={{ color: "#bbb" }}>
              <Box sx={{ display: "flex", mb: 1 }}>
                <LocationOn sx={{ mr: 1, mt: "3px", color: brandRed }} />
                Al Sajaa Industrial Area, Sharjah, UAE
              </Box>

              <Box
                component="a"
                href="tel:+971508517296"
                sx={{
                  width: "fit-content",
                  display: "flex",
                  mb: 1,
                  textDecoration: "none",
                  color: "inherit",
                  "&:hover .icon": { color: brandRed },
                  "&:hover": { color: brandRed },
                }}
              >
                <Phone
                  className="icon"
                  sx={{ mr: 1, mt: "3px", color: brandRed }}
                />
                +971 50 851 7296
              </Box>

              <Box
                component="a"
                href="mailto:info@burjalyarmouk.com"
                sx={{
                  width: "fit-content",
                  display: "flex",
                  mb: 1,
                  textDecoration: "none",
                  color: "inherit",
                  "&:hover .icon": { color: brandRed },
                  "&:hover": { color: brandRed },
                }}
              >
                <Email
                  className="icon"
                  sx={{ mr: 1, mt: "3px", color: brandRed }}
                />
                info@burjalyarmouk.com
              </Box>
            </Box>
          </Box>
        </Box>

        {/* ROW 2 — Products + Services (FLEXBOX) */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            gap: 6,
          }}
        >
          {/* Quick Links (Includes Privacy + Terms) */}
          <Box sx={{ flex: { xs: "100%", sm: "45%", md: "23%" } }}>
            <Typography
              sx={{
                fontWeight: "bold",
                mb: 2,
                textTransform: "uppercase",
              }}
            >
              Quick Links
            </Typography>

            {footerLinks.map((item) => (
              <Link
                key={item.label}
                component={RouterLink}
                to={item.url}
                underline="none"
                sx={{
                  width: "fit-content",
                  display: "block",
                  color: "#bbb",
                  mb: 1,
                  transition: "0.25s ease",
                  "&:hover": { color: brandRed, pl: 0.5 },
                }}
              >
                {item.label}
              </Link>
            ))}
          </Box>

          {/* Products */}
          {/* <Box sx={{ flex: "1 1 200px", minWidth: "200px" }}>
            <Typography
              variant="subtitle1"
              sx={{
                color: "#fff",
                fontWeight: "bold",
                mb: 2,
                textTransform: "uppercase",
              }}
            >
              Products
            </Typography>

            {productCategories.map((item) => {
              const slug = slugify(item);

              return (
                <Link
                  key={item}
                  component={RouterLink}
                  to={`/products/${slug}`}
                  underline="none"
                  sx={{
                    width: "fit-content",
                    display: "block",
                    color: "#bbb",
                    mb: 1,
                    transition: "0.25s ease",
                    "&:hover": { color: brandRed, pl: 0.5 },
                  }}
                >
                  {item}
                </Link>
              );
            })}
          </Box> */}

          {/* Services */}
          {/* <Box sx={{ flex: "1 1 200px", minWidth: "200px" }}>
            <Typography
              variant="subtitle1"
              sx={{
                color: "#fff",
                fontWeight: "bold",
                mb: 2,
                textTransform: "uppercase",
              }}
            >
              Services
            </Typography>

            {serviceCategories.map((item) => {
              const slug = slugify(item);

              return (
                <Link
                  key={item}
                  component={RouterLink}
                  to={`/services/${slug}`}
                  underline="none"
                  sx={{
                    width: "fit-content",
                    display: "block",
                    color: "#bbb",
                    mb: 1,
                    transition: "0.25s ease",
                    "&:hover": {
                      color: brandRed,
                      pl: 0.5,
                    },
                  }}
                >
                  {item}
                </Link>
              );
            })}
          </Box> */}
        </Box>

        <Divider sx={{ my: 4, borderColor: "#888" }} />

        {/* Bottom Copyright Bar */}
        <Box
          sx={{
            textAlign: "center",
            color: "#fff",
            fontSize: "0.85rem",
          }}
        >
          © {year} Burj Al Yarmouk Industries LLC — All Rights Reserved.
        </Box>
      </Container>
    </Box>
  );
}
